<template>
  <div class="mx-15" v-if="$vuetify.breakpoint.smAndUp">
    <v-row class="font-weight-bold dark-grey--text">
      <v-col md="2">{{ $t('label.expiryDate') }}</v-col>
      <v-col md="2">{{ $t('label.code') }}</v-col>
      <v-col md="3">{{ $t('label.vouchers') }}</v-col>
      <v-col md="3">{{ $t('label.type') }}</v-col>
      <v-col md="2" class="text-right">{{ $t('label.value') }}</v-col>
    </v-row>

    <div v-for="(voucher, index) in historyList" :key="voucher.voucher_id">
      <v-row class="voucher-row" @click="toDetails(voucher)">
        <v-col md="2" class="font-weight-medium grey--text">{{ voucher.redeem_end_date | shortDate }}</v-col>
        <v-col md="2" class="font-weight-medium light-grey--text text--lighten-1">{{ voucher.code }}</v-col>
        <v-col md="3" class="font-weight-medium">
          <p class="hover dark-grey--text">{{ voucher.name }}</p>
          <p class="text-subtitle-2 grey--text">{{ voucher.status === 'Is expired' ? (voucher.redeemed_date === null ? $t('label.voucherExpire') : $t('label.voucherRedeemed')) : '' }}</p>
        </v-col>
        <v-col md="3" class="font-weight-medium dark-grey--text">{{ voucher.category }}</v-col>
        <v-col md="2" class="text-right font-weight-medium primary--text text--darken-1">{{ voucher.display_value }}</v-col>
      </v-row>
      <v-divider v-if="index < historyList.length - 1" class="my-6"></v-divider>
    </div>
  </div>
  <div v-else>
    <v-row class="py-10" v-if="historyList.length >= 1">
      <v-col :cols="12" class="px-0" v-for="item in historyList" :key="item.id">
        <vouchers-ticket
          currency="SGD"
          :discountPercentage="0"
          :productId="item.voucher_id"
          :voucherTitle="item.name"
          :voucherValue="item.display_value"
          :voucherExpiry="item.redeem_end_date"
          :voucherType="item.category"
          :isAvailable="true"
          :isHistory="true"
          :voucherDetail="item"
        />
      </v-col>
    </v-row>
  </div>
</template>

<script>
import VouchersTicket from '../../views/Vouchers/VouchersTicket.vue'
export default {
  components: {
    VouchersTicket
  },
  props: ['historyList', 'type'],
  methods: {
    toDetails(voucher) {
      this.$router.push({
        name: this.$constants.ROUTE_NAME.WALLET_VOUCHER_DETAILS,
        params: { id: voucher.voucher_id },
        hash: `#${this.type}`
      })
    }
  }
}
</script>
<style lang="scss">
.voucher-row:hover {
  cursor: pointer;
}
.voucher-row:hover > div.col,
.voucher-row:hover > div.col > p {
  color: var(--v-light-green-base) !important;
}
</style>
